module.exports = __webpack_public_path__ + "static/book-60adba210bae8b49883c366f02c32e8a.png";